var ctaPopup = document.getElementById("cta-popup");

if( ctaPopup ) {

    var ctaPopupClose = ctaPopup.querySelector(".cta-popup__close");
    var ctaPopupTrigger = ctaPopup.querySelector(".cta-popup__trigger");

    var openCtaPopup = function() {
        if( ctaPopup ) {
            ctaPopup.classList.add('open');
        }
    }

    var closeCtaPopup = function() {
        if( ctaPopup ) {
            ctaPopup.classList.remove('open');
            setCookie( "hide_glaifa_cta-popup", 1, 1 );
        }
    }

    ctaPopupTrigger.addEventListener("click", function(e) {
        e.preventDefault();
        openCtaPopup();
    }, false);

    ctaPopupClose.addEventListener("click", function(e) {
        e.preventDefault();
        closeCtaPopup();
    }, false);

}


function setCookie( name, value, days ) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie( name ) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

function eraseCookie( name ) {   
    document.cookie = name+'=; Max-Age=-99999999;';  
}
